import { render } from "./WSEdit.vue?vue&type=template&id=6548893c&ts=true"
import script from "./WSEdit.vue?vue&type=script&lang=ts"
export * from "./WSEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__